
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-prohub",
      function () {
        return require("private-next-pages/what-is-prohub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-prohub"])
      });
    }
  